<template>
  <v-dialog max-width="300" v-model="isEditnameDialog" @click:outside="close">
    <v-card class="container-guest px-3 py-4" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-2 mb-4" :cols="12" align="start" justify="start">
          <span class="txt-guest-title">{{ 'Edit your name' }}</span>
        </v-col>
      </v-row>
      <v-row no-gutters align="center" justify="center">
        <v-text-field
          v-model="guestName"
          dense
          background-color="#1A272E"
          filled
          solo
          dark
          placeholder="Enter your name"
          autofocus
          class="px-4"
          :rules="[rules.required, rules.counter]"
        />
      </v-row>
      <v-row class="px-4 mt-1 mb-4" no-gutters align="center" justify="center">
        <v-col align="center" no-gutters>
          <v-btn block dark class="mr-2 white1--text" color="#6c6c6c" @click="close">
            {{ $t('cancel') }}
          </v-btn>
        </v-col>
        <v-col class="ml-5" align="center" no-gutters>
          <v-btn
            block
            :loading="isEditnameChange"
            :disabled="!nameActive"
            class="white1--text"
            color="#289067"
            @click="setUserUpdate"
          >
            {{ $t('Done') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
// import { isMobile } from '@/common/lib/strLib'
// import firebase from 'firebase/app'
import { setUserUpdate } from '@/services/api'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'EditnameDialog',
  props: { isEditnameDialog: Boolean },
  data() {
    return {
      guestName: '',
      isEditnameChange: false,
      rules: {
        required: (value) => !!value || 'Required',
        counter: (value) => value.length <= 30 || 'Max 30 characters',
      },
    }
  },
  methods: {
    async setUserUpdate() {
      this.isEditnameChange = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        let result = await setUserUpdate(this, this.guestName, this.guestName)
        this.$store.commit('setUserInfo', result)
        // notify(this, 'Success', this.$t('updateSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('updateSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        this.close()
      } catch (error) {
        this.errorCode = error.response.status
        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        this.showMsg = true
      } finally {
        this.isEditnameChange = false
      }
    },
    close() {
      this.$emit('close', 'EditName')
    },
  },
  computed: {
    nameActive() {
      if (this.guestName) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.container-guest {
  border-radius: 24px !important;
}
.txt-guest-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.txt-guest-desc-name,
.txt-guest-desc-email,
.txt-guest-desc-verification {
  font-weight: 400;
  font-size: 15px;
  color: #96a7af;
  text-align: left;
}
.txt-guest-accent {
  font-weight: 600;
  color: #25c685;
}
.txt-guest-bold {
  font-weight: 600;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.v-btn:disabled.v-btn--has-bg {
  background-color: #6c6c6c !important;
  color: #eee !important;
}
.v-text-field >>> .v-text-field__details {
  margin-top: 2px !important;
}
</style>
